import { IconProps } from "./types";
import React from "react";

export const VerticalEllipsisIcon = ({
  className,
  fill = "currentColor",
  width = 12,
  height = 12,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    <path
      d="M12 14.248C13.2426 14.248 14.25 13.2407 14.25 11.998C14.25 10.7554 13.2426 9.74805 12 9.74805C10.7574 9.74805 9.75 10.7554 9.75 11.998C9.75 13.2407 10.7574 14.248 12 14.248Z"
      fill={fill}
    />
    <path
      d="M12 21.748C13.2426 21.748 14.25 20.7407 14.25 19.498C14.25 18.2554 13.2426 17.248 12 17.248C10.7574 17.248 9.75 18.2554 9.75 19.498C9.75 20.7407 10.7574 21.748 12 21.748Z"
      fill={fill}
    />
    <path
      d="M12 6.74414C13.2426 6.74414 14.25 5.73678 14.25 4.49414C14.25 3.2515 13.2426 2.24414 12 2.24414C10.7574 2.24414 9.75 3.2515 9.75 4.49414C9.75 5.73678 10.7574 6.74414 12 6.74414Z"
      fill={fill}
    />
  </svg>
);
